import { ISideBarNotification } from "..";

export class SideBarNotification {
  objectType: string;
  resultName: string;
  objectId: string;
  status: string;
  message: string;
  iconStyle: string;
  icon: string;

  constructor(sidebarNotification: ISideBarNotification) {
    this.objectType = sidebarNotification.objectType;
    this.resultName = sidebarNotification.resultName;
    this.objectId = sidebarNotification.objectId;
    this.status = sidebarNotification.status.toUpperCase();
    switch (this.status) {
      case 'SUCCESS': {
        this.message = 'Search <strong>' +  this.resultName + '</strong> has completed';
        this.iconStyle = 'text-success';
        this.icon = 'check_circle';
        break;
      }
      case 'SENT': {
        this.message = 'Search <strong>' +  this.resultName + '</strong> is pending';
        this.iconStyle = 'text-info';
        this.icon = 'info';
        break;
      }
      default: {
        this.message = 'Search <strong>' +  this.resultName + '</strong> has failed';
        this.iconStyle = 'text-danger';
        this.icon = 'warning';
      }
    }
  }
}
